import { useRef, useState } from "react";
import { Search, Check } from "lucide-react";
import { Input } from "@/components/ui/input";

const LIMIT = 50;

// Type-to-search picker for long lists (owners, drivers, buses)
export default function SearchSelect({ value, onChange, options, placeholder = "Type to search", testid }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const cur = options.find((o) => o.value === value);
  const words = q.toLowerCase().split(/\s+/).filter(Boolean);
  const hits = options.filter((o) => words.every((w) => `${o.label} ${o.sub || ""}`.toLowerCase().includes(w)));
  const pick = (o) => { onChange(o.value); setOpen(false); setQ(""); ref.current?.blur(); };
  return (
    <div className="relative">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <Input ref={ref} value={q || (cur ? cur.label : "")} placeholder={placeholder} className="pl-9" data-testid={testid} autoComplete="off"
        onFocus={(e) => { setOpen(true); setQ(""); e.target.select(); }} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onBlur={() => setTimeout(() => { setOpen(false); setQ(""); }, 150)}
        onKeyDown={(e) => { if (e.key === "Enter" && hits[0]) { e.preventDefault(); pick(hits[0]); } if (e.key === "Escape") setOpen(false); }} />
      {cur && !open && cur.sub && <div className="mt-1 text-xs text-slate-500" data-testid={`${testid}-selected`}>{cur.sub}</div>}
      {open && (
        <div className="absolute z-50 mt-1 max-h-64 w-full overflow-y-auto rounded-xl border border-slate-200 bg-white p-1 shadow-lg" data-testid={`${testid}-results`}>
          {hits.slice(0, LIMIT).map((o) => (
            <button type="button" key={o.value} onMouseDown={(e) => { e.preventDefault(); pick(o); }}
              className="flex w-full items-center justify-between gap-2 rounded-lg px-3 py-2 text-left text-sm transition-colors hover:bg-blue-50" data-testid={`${testid}-option-${o.value}`}>
              <span><span className="font-semibold">{o.label}</span>{o.sub && <span className="block text-xs text-slate-500">{o.sub}</span>}</span>
              {o.value === value && <Check className="h-4 w-4 text-[#0052FF]" />}
            </button>
          ))}
          {!hits.length && <div className="px-3 py-2 text-sm text-slate-500" data-testid={`${testid}-no-results`}>No match for "{q}"</div>}
          {hits.length > LIMIT && <div className="px-3 py-2 text-xs text-slate-400">{hits.length - LIMIT} more - keep typing to narrow down</div>}
        </div>
      )}
    </div>
  );
}
